import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const AMENITY_ICON_MAP = {
  accessible: 'valet-glyph-amenity-accessibility',
  attended: 'amenity-icon-attended',
  attended_alltimes: 'valet-glyph-user',
  attended_arrival: 'valet-glyph-user',
  covered: 'valet-glyph-amenity-covered',
  vehicle_charging: 'amenity-icon-vehicle-charging',
  eticket: 'valet-glyph-amenity-mobilepass',
  handicap: 'amenity-icon-handicap',
  has_gallery: 'valet-glyph-image',
  indoor: 'amenity-icon-covered',
  mobile_pass: 'valet-glyph-amenity-mobilepass',
  obstructed: 'amenity-icon-obstructed',
  perk: 'valet-glyph-star-filled',
  price_premium: 'valet-glyph-tag',
  printed_pass: 'amenity-icon-printed',
  restrooms: 'amenity-icon-restroom',
  restroom: 'amenity-icon-restroom',
  rv: 'valet-glyph-amenity-rv',
  security: 'amenity-icon-security',
  shuttle: 'amenity-icon-shuttle',
  shuttle_to_venue: 'valet-glyph-amenity-shuttle',
  shuttle_from_venue: 'valet-glyph-amenity-shuttle',
  tailgate: 'amenity-icon-tailgate',
  unobstructed: 'amenity-icon-unobstructed',
  valet: 'amenity-icon-valet',
  reentry: 'amenity-icon-reentry',
  reentry_allowed: 'amenity-icon-reentry',
};

const propTypes = {
  amenityKey: PropTypes.string,
  name: PropTypes.string,
  enabled: PropTypes.bool,
  iconClassName: PropTypes.string,
  className: PropTypes.string,
};

const defaultProps = {
  amenityKey: '',
  name: '',
  enabled: true,
  iconClassName: '',
  className: '',
};

export const getAmenityIconClass = (amenityKey, enabled = true) => {
  const normalizedKey = (amenityKey || '').toLowerCase();
  if (normalizedKey === 'unobstructed') {
    return enabled ? 'amenity-icon-unobstructed' : 'amenity-icon-obstructed';
  }
  if (normalizedKey === 'reentry' || normalizedKey === 'reentry_allowed') {
    return enabled ? 'amenity-icon-reentry' : 'amenity-icon-no-reentry';
  }
  const baseIcon = AMENITY_ICON_MAP[normalizedKey] || null;
  if (!baseIcon) {
    return '';
  }
  return enabled ? baseIcon : `${baseIcon} disabled`;
};

export const AmenityIcon = ({
  amenityKey,
  name,
  enabled,
  iconClassName,
  className,
}) => {
  const resolvedIcon = iconClassName || getAmenityIconClass(amenityKey || name, enabled);

  return <div className={cx(resolvedIcon, className)} />;
};

AmenityIcon.propTypes = propTypes;
AmenityIcon.defaultProps = defaultProps;

export default AmenityIcon;
